import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-300">404</h1>
        </div>
        
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {t('notFound.title', 'Страница не найдена')}
          </h2>
          <p className="text-gray-600 text-lg max-w-md mx-auto">
            {t('notFound.description', 'К сожалению, запрашиваемая страница не существует или была перемещена.')}
          </p>
        </div>
        
        <div className="space-y-4">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              {t('notFound.goBack', 'Назад')}
            </button>
            
            <Link
              to="/"
              className="px-6 py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors"
            >
              {t('notFound.goHome', 'На главную')}
            </Link>
          </div>
          
          <div className="pt-8">
            <p className="text-gray-500 text-sm mb-4">
              {t('notFound.suggestions', 'Возможно, вас заинтересует:')}
            </p>
            
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <Link 
                to="/shop" 
                className="text-gray-600 hover:text-black transition-colors"
              >
                {t('nav.shop', 'Магазин')}
              </Link>
              
              <Link 
                to="/courses" 
                className="text-gray-600 hover:text-black transition-colors"
              >
                {t('nav.courses', 'Курсы')}
              </Link>
              
              <Link 
                to="/#portfolio" 
                className="text-gray-600 hover:text-black transition-colors"
              >
                {t('nav.portfolio', 'Портфолио')}
              </Link>
              
              <Link 
                to="/about" 
                className="text-gray-600 hover:text-black transition-colors"
              >
                {t('nav.about', 'О мне')}
              </Link>
              
              <Link 
                to="/contact" 
                className="text-gray-600 hover:text-black transition-colors"
              >
                {t('nav.contact', 'Контакты')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
